// import defaultData from './category.json';

export default class AntCategory {
    constructor(data, session) {
        this.data = data;
    }

    getCats() {
        var codes = [];
        var ar = [];
        for (var i = 0; i < this.data.length; i++) {
            var item = this.data[i];
            if (codes.indexOf(item.CAT1_CODE) <= -1) {
                codes.push(item.CAT1_CODE);
                ar.push({
                    code: item.CAT1_CODE,
                    name: item.CAT1_NAME_VI
                });
            }
            if (codes.indexOf(item.CAT2_CODE) <= -1) {
                codes.push(item.CAT2_CODE);
                ar.push({
                    code: item.CAT2_CODE,
                    name: item.CAT2_NAME_VI
                });
            }
            if (codes.indexOf(item.CAT3_CODE) <= -1) {
                codes.push(item.CAT3_CODE);
                ar.push({
                    code: item.CAT3_CODE,
                    name: item.CAT3_NAME_VI
                });
            }
        }
        return ar.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    getCat1s() {
        var cat1_codes = [];
        var cat1s = [];
        for (var i = 0; i < this.data.length; i++) {
            var item = this.data[i];
            if (cat1_codes.indexOf(item.CAT1_CODE) <= -1) {
                cat1_codes.push(item.CAT1_CODE);
                cat1s.push({
                    code: item.CAT1_CODE,
                    name: item.CAT1_NAME_VI
                });
            }
        }
        return cat1s.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    getCat1(code) {
        var obj = this.data.find((a) => a.CAT1_CODE == code);
        if (obj)
            return {
                code: obj.CAT1_CODE,
                name: obj.CAT1_NAME_VI
            };

        return null;
    }

    getCat2s(cat1_code) {
        var cat2_codes = [];
        var cat2s = [];
        for (var i = 0; i < this.data.length; i++) {
            var item = this.data[i];
            if (item.CAT1_CODE == cat1_code && cat2_codes.indexOf(item.CAT2_CODE) <= -1) {
                cat2_codes.push(item.CAT2_CODE);
                cat2s.push({
                    code: item.CAT2_CODE,
                    name: item.CAT2_NAME_VI
                });
            }
        }

        return cat2s.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    getCat2(code) {
        var obj = this.data.find((a) => a.CAT2_CODE == code);
        if (obj)
            return {
                code: obj.CAT2_CODE,
                name: obj.CAT2_NAME_VI
            };

        return null;
    }

    getCat3s(cat2_code) {
        var cat3_codes = [];
        var cat3s = [];
        for (var i = 0; i < this.data.length; i++) {
            var item = this.data[i];
            if (item.CAT2_CODE == cat2_code && cat3_codes.indexOf(item.CAT3_CODE) <= -1) {
                cat3_codes.push(item.CAT3_CODE);
                cat3s.push({
                    code: item.CAT3_CODE,
                    name: item.CAT3_NAME_VI
                });
            }
        }

        return cat3s.sort((a, b) => (a.name > b.name ? 1 : -1));
    }

    getCat3(code) {
        var obj = this.data.find((a) => a.CAT3_CODE == code);
        if (obj)
            return {
                code: obj.CAT3_CODE,
                name: obj.CAT3_NAME_VI
            };

        return null;
    }
}
